import React, { useState, useEffect } from 'react';
import { Container, Navbar, Nav, Image, Dropdown, ProgressBar,Button } from 'react-bootstrap';
import { useLogin } from '../../../context/LoginContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { BellIcon, Signout, UserTrackingIcon, TOGELUSERICON, GearIcon} from "../../../utils/FontIcon";
import { getDisplayNameFromRole } from '../../../utils/rolemap';
import { useCourse } from '../../../context/CourseContext';
import { useImageWithFallback, isSamePath,formatDate} from '../../../utils/utils';
import LiveUserCount from './LiveUserCount';

const CourseImage = ({ course }) => {
  const thumbnailUrl = course?.thumbnailUrl || '/lms/img/no-video-icon.png';
  const fallbackUrl = '/lms/img/no-video-icon.png';
  const [imgSrc, handleImgError] = useImageWithFallback(thumbnailUrl, fallbackUrl);
  return (
    <img src={imgSrc} onError={handleImgError} alt={course.title} style={{ width: '100%', height: '100%' }} />
  );
}

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, logout, user, switchUser } = useLogin();
  const { userCourse } = useCourse();
  const [inprogressCourse, setInprogressCourse] = useState([]);
  useEffect(() => {
    if (userCourse?.length) {
      const inprogress = userCourse.filter(course => course.progressPercent < 100 && course.progressPercent > 0);
      setInprogressCourse(inprogress);
    }
  }, [userCourse])
  
  const onHandelClick = () => {
    navigate('/home');
  };
  const onHandelLogout = () => {
    logout(() => {
      navigate('/');
    });
  };
  const getIntialName = (name) => {
    if (!name) return '';
    const parts = name.split(' ');
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    } else {
      return parts[0].charAt(0).toUpperCase() + parts[1].charAt(0).toUpperCase();
    }
  };
  const getAllDisplayName = () => {
    const roles = user?.roles?.map((role) => {
      return role?.displayUserType ? role?.displayUserType : "External User";
    })
   
    if(roles)
      return roles?.join();
   
  }
  const onHandelSettings = (e) => {
    navigate('/adminsettings');
  }
  const onHandelReports=(e)=>{
    navigate('/reports');
  }

  return (
    <header className='myTopNav' style={{padding:'0px'}}>
      <Navbar expand="lg" className="border-bottom shadow-sm py-1">
        <Container fluid className="align-items-center l-height16">
          {isLoggedIn ?
            <Navbar.Brand className="d-flex align-items-center" onClick={onHandelClick} title="LMS Logo & Name" style={{ cursor: 'pointer' }}>
              <Image src={'https://pmfby.amnex.co.in/pmfby/public/img/logo-product.svg'} width={40} height={40} className="me-2" alt="LMS Logo" />
              {/* <Image src={'https://pmfby.amnex.co.in/pmfby/public/img/logo-product.svg'} width={36} height={36} className="me-2" alt="LMS Logo" /> */}
              <div>
                <div className="fw-600 lms-heading" style={{ fontSize: '1rem', lineHeight: '12px', padding: '0px', margin: '0px' }}>Learning Management System (LMS)</div>
                <small className="text-muted" style={{ fontSize: '0.6875rem', lineHeight: '10px', letterSpacing: '0.1rem' }}>Empowering Agriculture through Knowledge</small>
              </div>
            </Navbar.Brand> :
            <div className='goi-logo'>
              <img src="https://pmfby.amnex.co.in/pmfby/public/img/logo.svg" alt="Govt. of India National Emblem" title="Govt. of India National Emblem"></img>
              <ul className='d-none d-lg-block'>
                <li><span className='d-block'>भारत सरकार</span><span>GOVERNMENT OF INDIA</span></li>
                <li><span className='d-block'>कृषि एवं किसान कल्याण मंत्रालय</span><span>MINISTRY OF AGRICULTURE &amp; FARMERS WELFARE</span></li>
              </ul>
               <ul className='d-block d-lg-none'>
                <li><span className='d-block'>कृषि एवं किसान कल्याण मंत्रालय | भारत सरकार</span><span>MoAFW, Government of India</span></li>
              </ul>
            </div>
          }
          {isLoggedIn ?
            <Nav className="ms-auto d-flex align-items-center my-innermenu">
               <a href='#' onClick={onHandelClick}><i className="fa fa-home" aria-hidden="true" style={{fontSize: '1.25rem', color:'#231444'}}></i></a>
              {user.selectedRole === 'viewer' && (               
                <Dropdown align="start">
                  <Dropdown.Toggle variant='' id="mylearnign-info" className="d-flex align-items-center border-0 usermenu-ddl me-2">
                    My Learning
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {inprogressCourse?.length ? inprogressCourse.map((course, idx) => (
                      <Dropdown.Item key={idx} onClick={() => navigate(`/viewcourses/${course._id}`)}>
                        <div className="d-flex align-items-start" style={{ minHeight: '70' }}>
                          <div style={{ width: 60, height: 60, overflow: 'hidden', borderRadius: 8, marginRight: 12, cursor: 'pointer' }}>
                            <CourseImage course={course} />
                          </div>
                          <div style={{ flex: 1 }}>
                            <span style={{ width: '250px', display: 'block', whiteSpace: 'normal' }}>{course.title}</span>
                            <ProgressBar
                              now={course?.progressPercent || 0}
                              style={{ height: '3px', background: '#e9ecef', }}
                              variant="dark"
                            />
                            <small className='d-block'> {`${course?.progressPercent || 0}%`} complete</small>
                          </div>
                        </div>
                      </Dropdown.Item>
                    )) :
                      <Dropdown.Item disabled>No ongoing courses</Dropdown.Item>}
                  </Dropdown.Menu>
                </Dropdown>
              )

              }
              <LiveUserCount onlyNumber={false} />
              <Dropdown align="end">
                <Dropdown.Toggle variant="light" id="dropdown-basic" className="d-flex align-items-center border-0 usermenu-ddl" title='User Icon & Submenu'>
                  <div className="rounded-circle border border-warning d-flex justify-content-center align-items-center me-1"
                    style={{ width: '40px', height: '40px', color: '#f6a400', fontWeight: 'bold' }}>
                    {getIntialName(user?.name)}
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <p className='border-bottom p-2 px-3 mb-2' style={{ lineHeight: '1.1rem' }}>
                    <strong className='d-block'>{user?.name}</strong>
                    <small className='text-muted d-block'>{`${getDisplayNameFromRole(user?.selectedRole)}`}</small>
                    <small className='text-muted d-block'>({`${getAllDisplayName()}`})</small>
                    <small className='text-muted'>Last Login: {user?.lastLoginAt ? formatDate(user?.lastLoginAt,false) : 'Never'}</small>
                  </p>

                  <Dropdown.Item onClick={() => navigate('/profile')}>
                    <i className="fa fa-user-circle-o me-1" aria-hidden="true"></i> My Profile
                  </Dropdown.Item>
                  {(user?.lmsRoles === 'approver' || user?.lmsRoles === 'creater') &&
                    (<>
                      <Dropdown.Item onClick={() => {
                        switchUser(() => {
                          const issame = isSamePath(location, '/home')
                          if (issame) {
                            window.location.reload();
                            return;
                          }
                          navigate('/home');
                        });
                      }}>
                        <TOGELUSERICON />
                        {`Switch to ${user?.selectedRole == 'viewer' ? user.lmsRoles : getDisplayNameFromRole('viewer')}`}
                      </Dropdown.Item>
                      {user?.selectedRole === 'viewer' ? null : <Dropdown.Item onClick={onHandelReports}><UserTrackingIcon /> Reports</Dropdown.Item> }
                      {user?.selectedRole === 'approver' ?
                        <Dropdown.Item onClick={onHandelSettings}><GearIcon /> Settings</Dropdown.Item>
                        : null}
                    </>)
                  }
                  <Dropdown.Item href="" onClick={onHandelLogout}><Signout /> Logout</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav> :
            <Navbar.Brand onClick={() => { navigate('/') }} className="d-flex align-items-center" style={{ cursor: 'pointer' }} title="LMS Logo & Name">
              <Image src={'https://pmfby.amnex.co.in/pmfby/public/img/logo-product.svg'} width={40} height={40} className="me-2" alt="LMS Logo" />
              <div>
                <div className="fw-600" style={{ fontSize: '16px', lineHeight: '12px', padding: '0PX', margin: '0px' }}>Learning Management System (LMS)</div>
                <small className="text-muted" style={{ fontSize: '11px', lineHeight: '10px', letterSpacing: '0.1rem' }}>Empowering Agriculture through Knowledge</small>
              </div>
            </Navbar.Brand>
          }
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
